import { useState } from "react";
import { toast } from "sonner";
import { Send, Check } from "lucide-react";
import { api } from "../lib/api";
import { Reveal } from "./Reveal";
import { Badge } from "./Pill";

export default function NewsletterBlock() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api("/newsletter", { method: "POST", body: { email } });
      setDone(true);
      toast.success(res.already ? "You are already on the list" : "Welcome to The Weekly Edit");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <section data-testid="newsletter-section" className="bg-ink text-cream py-20 md:py-24">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <Reveal><Badge tone="gold">The Weekly Edit</Badge></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display uppercase text-4xl md:text-5xl leading-[0.98]">
            One email. Every week. Zero noise.
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-5 text-cream/60 leading-relaxed max-w-xl mx-auto">
            The five stories our editors loved most, the trends worth your attention and one real wedding you have to
            see. Straight to your inbox.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          {done ? (
            <div className="mt-9 inline-flex items-center gap-3 rounded-full bg-cream/10 border border-champagne/40 px-7 py-4" data-testid="newsletter-success">
              <Check size={16} className="text-champagne" />
              <span className="text-sm">You are on the list. See you this week.</span>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-9 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="newsletter-email-input"
                placeholder="Your email address"
                className="flex-1 rounded-full bg-cream/10 border-2 border-cream/20 px-6 py-4 text-sm text-cream placeholder:text-cream/40 outline-none focus:border-champagne transition-colors duration-300"
              />
              <button
                type="submit"
                data-testid="newsletter-subscribe-button"
                disabled={busy}
                className="inline-flex items-center justify-center gap-2 bg-champagne text-ink rounded-full px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] hover:bg-cream transition-colors duration-300 disabled:opacity-50"
              >
                {busy ? "Joining" : "Subscribe"} <Send size={13} />
              </button>
            </form>
          )}
        </Reveal>
      </div>
    </section>
  );
}
